module.exports = __webpack_public_path__ + "static/media/classexplain.b4cd7a51.png";